import { checkPermission } from '@/api/user';
export default {
	data() {
		return {
			checkTalentCRMPermission: {
				auth: false,
			},
		};
	},
	created() {
		this.checkHasTalentCRMPermission();
	},
	provide() {
		return {
			checkTalentCRMPermission: this.checkTalentCRMPermission,
		};
	},
	methods: {
		// 检测当前登录的租户账号是否有’插件找达人‘权限
		async checkHasTalentCRMPermission() {
			const res = await checkPermission({ permission: 'talentCRM:clueSeas:dyAlliance' });
			this.checkTalentCRMPermission.auth = res.havePermission;
		},
	},
};
